import { X } from 'lucide-react'
import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export const badgeTones = {
  neutral: 'bg-muted text-muted-foreground',
  accent: 'bg-accent text-accent-foreground',
  success: 'bg-success text-success-foreground',
  warning: 'bg-warning text-warning-foreground',
  danger: 'bg-danger text-danger-foreground',
}
export function Badge({
  className,
  tone = 'neutral',
  appearance = 'subtle',
  removeLabel,
  onRemove,
  children,
  ...props
}: ComponentProps<'span'> & {
  tone?: keyof typeof badgeTones
  appearance?: 'subtle' | 'outline'
} & ({ removeLabel?: never; onRemove?: never } | { removeLabel: string; onRemove: () => void })) {
  return (
    <span
      {...props}
      data-slot="badge"
      className={cn(
        'inline-flex max-w-full items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        badgeTones[tone],
        appearance === 'outline' && 'border border-current bg-transparent',
        className,
      )}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          aria-label={removeLabel}
          onClick={onRemove}
          className="-my-1 -mr-1.5 grid size-6 shrink-0 cursor-pointer place-items-center rounded-full transition-colors hover:bg-current/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring motion-reduce:transition-none"
        >
          <X aria-hidden="true" className="size-3.5" />
        </button>
      )}
    </span>
  )
}
